import api from "api";
import { useState } from "react";
import { formErrorStrfromObj } from "utils/shared";
import _ from "lodash";
import { useDispatch } from "react-redux";
import {
  setOpenDialog,
  setLoading,
  setDialogMessage,
  setDialogTitle,
  setDialog,
} from "slices/appSlice";

export const useHealthcheck = () => {
  const dispatch = useDispatch();
  const [healthcheckStatus, setHealthcheckStatus] = useState(null);

  const fetchHealthCheck = async () => {
    try {
      const response = await api.healthcheck.healthcheck();
    } catch (e) {
      if (e?.response?.data?.data) {
        const healthCheckStatus = e.response.data.data;
        setHealthcheckStatus(healthCheckStatus);
        const failedChecks = Object.keys(
          _.pickBy(
            healthCheckStatus,
            (v, k) => v !== "OK" && k !== "GIT_COMMIT"
          )
        );
        if (failedChecks.length) {
          dispatch(
            setDialogMessage(`
                Application is experiencing connectivity issues with ${failedChecks.join(",")}.
                Please try again and contact Avalon Support if the issue persists.`)
          );
          dispatch(setDialogTitle("Error"));
          dispatch(setOpenDialog(true));
        }
      } else if (e)
        dispatch(
          setDialog({ title: "Error", message: formErrorStrfromObj(e) })
        );
    } finally {
      dispatch(setLoading(false));
    }
  };
  return [healthcheckStatus, fetchHealthCheck];
};
